import App from './Main.svelte';

new App({
  target: document.body,
});

